(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amigos-store-hours"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('amigos-store-hours')) return;
    const WEEK = 10080;
    const DAY = 1440;
    const dayNumbers = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    const actionLabels = /^(legg (?:til|i) (?:handlekurv|kurv)|add to (?:cart|bag)|kjøp nå|buy (?:it )?now|til (?:kassen|betaling)|gå til (?:kassen|betaling)|(?:proceed to )?checkout|bestill nå|betal nå|complete order)(?:\s|$)/i;

    class AmigosStoreHours extends HTMLElement {
      connectedCallback() {
        if (this.running) return;
        this.running = true;
        this.marked = new Map();
        this.notice = this.querySelector('.amigos-hours-notice');
        this.heading = this.querySelector('[data-hours-heading]');
        this.next = this.querySelector('[data-hours-next]');
        try {
          this.config = JSON.parse(this.querySelector('[data-hours-config]').textContent);
          this.clock = new Intl.DateTimeFormat('en-GB', {
            timeZone: 'Europe/Oslo', year: 'numeric', month: 'numeric', day: 'numeric',
            weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23'
          });
          this.intervals = this.parseDays(this.config.days, Number(this.config.cutoff || 0));
          this.valid = true;
        } catch {
          this.valid = false;
        }
        this.onClick = event => {
          const target = event.composedPath().find(node => node instanceof Element && node.matches('a, button, [role="button"], input[type="submit"], [data-amigos-order-button], [data-amigos-hours-blocked]'));
          if (this.state().open || !target || !this.isOrderingControl(target)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.update();
          this.notice.focus({ preventScroll: true });
        };
        this.onSubmit = event => {
          const form = event.target;
          if (!(form instanceof HTMLFormElement) || this.state().open) return;
          const path = this.localPath(form.action);
          const buying = /\/cart\/add(?:\.js)?\/?$/.test(path) || /\/checkouts?(?:\/|$)/.test(path) ||
            (event.submitter && this.isOrderingControl(event.submitter));
          if (!buying) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.update();
          this.notice.focus({ preventScroll: true });
        };
        this.refresh = () => this.update();
        this.observer = new MutationObserver(() => {
          if (!this.pending) this.pending = setTimeout(() => { this.pending = null; this.update(); }, 80);
        });
        this.observer.observe(document.body, {
          childList: true, subtree: true, attributes: true,
          attributeFilter: ['href', 'action', 'name', 'data-amigos-order-button']
        });
        document.addEventListener('click', this.onClick, true);
        document.addEventListener('submit', this.onSubmit, true);
        document.addEventListener('visibilitychange', this.refresh);
        window.addEventListener('focus', this.refresh);
        window.addEventListener('pageshow', this.refresh);
        this.timer = setInterval(this.refresh, 10000);
        this.update();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        clearTimeout(this.pending);
        clearInterval(this.timer);
        document.removeEventListener('click', this.onClick, true);
        document.removeEventListener('submit', this.onSubmit, true);
        document.removeEventListener('visibilitychange', this.refresh);
        window.removeEventListener('focus', this.refresh);
        window.removeEventListener('pageshow', this.refresh);
        this.restore();
        document.documentElement.classList.remove('amigos-ordering-closed');
        this.running = false;
      }

      parseDays(days, cutoff) {
        if (!Array.isArray(days) || days.length !== 7 || !Number.isFinite(cutoff) || cutoff < 0) throw new Error('Invalid schedule');
        const intervals = [];
        days.forEach((value, day) => {
          const text = String(value || '').trim();
          if (!text || /^(stengt|closed|-)$/i.test(text)) return;
          for (const slot of text.split(',')) {
            const match = slot.trim().match(/^(\d{2}):(\d{2})\s*[-–]\s*(\d{2}):(\d{2})$/);
            if (!match) throw new Error('Invalid time');
            const [oh, om, ch, cm] = match.slice(1).map(Number);
            if (oh > 23 || om > 59 || ch > 24 || cm > 59 || (ch === 24 && cm !== 0)) throw new Error('Invalid time');
            const from = oh * 60 + om;
            let to = ch * 60 + cm;
            if (to === from) throw new Error('Equal times');
            if (to < from) to += DAY;
            const start = day * DAY + from;
            const end = day * DAY + to - cutoff;
            if (end > start) intervals.push({ start, end });
          }
        });
        return intervals;
      }

      state(now = new Date()) {
        if (this.config?.enabled === false) return { open: true };
        if (!this.valid || this.config?.forceClosed) return { open: false, invalid: !this.valid };
        try {
          const parts = Object.fromEntries(this.clock.formatToParts(now).map(p => [p.type, p.value]));
          const minute = dayNumbers[parts.weekday] * DAY + Number(parts.hour) * 60 + Number(parts.minute);
          if (!Number.isFinite(minute)) throw new Error('Invalid clock');
          const open = this.intervals.some(({ start, end }) =>
            (minute >= start && minute < end) || (minute + WEEK >= start && minute + WEEK < end));
          if (open) return { open: true };
          const wait = this.intervals.length ? Math.min(...this.intervals.map(({ start }) => (start - minute + WEEK) % WEEK)) : null;
          if (wait === null) return { open: false };
          const dayOffset = Math.floor((Number(parts.hour) * 60 + Number(parts.minute) + wait) / DAY);
          const date = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day) + dayOffset));
          const weekday = new Intl.DateTimeFormat('nb-NO', { timeZone: 'UTC', weekday: 'long' }).format(date);
          const time = (minute + wait) % DAY;
          return { open: false, next: `${weekday} ${String(Math.floor(time / 60)).padStart(2, '0')}:${String(time % 60).padStart(2, '0')}` };
        } catch {
          return { open: false, invalid: true };
        }
      }

      localPath(value) {
        try {
          const url = new URL(value, window.location.href);
          return url.origin === window.location.origin ? url.pathname : '';
        } catch { return ''; }
      }

      isOrderingControl(element) {
        if (element.hasAttribute('data-amigos-order-button')) return true;
        if (element.matches('[name="checkout"], [name="add"], #checkout, [data-checkout]')) return true;
        if (element.closest('.shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart')) return true;
        if (element.tagName === 'A') {
          const path = this.localPath(element.href);
          if (/\/checkouts?(?:\/|$)/.test(path) || /\/cart\/(?:add|\d)/.test(path)) return true;
        }
        const form = element.form || element.closest('form');
        if (form && /\/cart\/add(?:\.js)?\/?$/.test(this.localPath(form.action))) {
          if (element.matches('button:not([type]), button[type="submit"], input[type="submit"]')) return true;
        }
        return [element.textContent, element.value, element.getAttribute('aria-label')].some(text => actionLabels.test((text || '').trim()));
      }

      restore() {
        for (const [element, before] of this.marked || []) {
          element.removeAttribute('data-amigos-hours-blocked');
          if (element.getAttribute('aria-disabled') === 'true') {
            if (before === null) element.removeAttribute('aria-disabled');
            else element.setAttribute('aria-disabled', before);
          }
        }
        this.marked?.clear();
      }

      update() {
        const state = this.state();
        document.documentElement.classList.toggle('amigos-ordering-closed', !state.open);
        this.notice.hidden = state.open;
        if (state.open) { this.restore(); return; }
        const messages = this.config?.messages || {};
        const heading = state.invalid ? messages.unavailable : messages.closed;
        const next = state.next ? `${messages.next} ${state.next}` : '';
        if (this.heading.textContent !== heading) this.heading.textContent = heading || '';
        if (this.next.textContent !== next) this.next.textContent = next;
        for (const element of document.querySelectorAll('button, [role="button"], a[href], input[type="submit"], [data-amigos-order-button]')) {
          if (!this.isOrderingControl(element)) continue;
          if (!this.marked.has(element)) this.marked.set(element, element.getAttribute('aria-disabled'));
          element.setAttribute('data-amigos-hours-blocked', 'true');
          element.setAttribute('aria-disabled', 'true');
        }
        for (const [element, before] of this.marked) {
          if (!element.isConnected || !this.isOrderingControl(element)) {
            element.removeAttribute('data-amigos-hours-blocked');
            if (element.getAttribute('aria-disabled') === 'true') {
              if (before === null) element.removeAttribute('aria-disabled');
              else element.setAttribute('aria-disabled', before);
            }
            this.marked.delete(element);
          }
        }
      }
    }
    customElements.define('amigos-store-hours', AmigosStoreHours);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
